import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MagnifyingGlass, ShoppingCart, UserCircle, ChatCircle, List } from '@phosphor-icons/react';
import { dummyStoreInfo } from '../dummyData';

const TemplateHeader = ({ colors = {}, websiteData }) => {
    const location = useLocation();
    const currentPath = location.pathname;

    return (
        <header className="bg-white">
            {/* Desktop Header */}
            <div className="d-none d-md-block">
                {/* Top Bar */}
                <div className="py-6" style={{ backgroundColor: colors.primary || '#000' }}>
                    <div className="container d-flex justify-content-end text-14">
                        <Link
                            to="/account"
                            className="d-flex align-items-center gap-1 text-decoration-none"
                            style={{ cursor: 'pointer', color: colors.accountTitle || '#fff' }}
                        >
                            <UserCircle size={18} />
                            <span>My Account</span>
                        </Link>
                    </div>
                </div>

                {/* Main Logo Area */}
                <div className="py-24 border-bottom border-gray-100">
                    <div className="container d-flex justify-content-between align-items-center">
                        {/* Left spacer for centering */}
                        <div style={{ flex: 1 }}></div>

                        {/* Center: Logo */}
                        <div className="text-center" style={{ flex: 1 }}>
                            <img src={websiteData?.websiteLogo || websiteData?.shopLogo || dummyStoreInfo.logo} alt="Company Logo" style={{ maxHeight: '48px', objectFit: 'contain' }} />
                        </div>

                        {/* Right: Icons */}
                        <div className="d-flex align-items-center justify-content-end gap-4" style={{ flex: 1 }}>
                            <ChatCircle size={24} className="text-gray-800" style={{ cursor: 'pointer' }} />
                            <Link
                                to="/cart"
                                className="position-relative d-flex align-items-center justify-content-center text-decoration-none"
                                style={{ width: '24px', height: '24px', cursor: 'pointer' }}
                            >
                                <ShoppingCart size={24} className="text-gray-800" />
                                <span
                                    className="position-absolute translate-middle badge rounded-circle d-flex align-items-center justify-content-center"
                                    style={{
                                        backgroundColor: colors.bubble || '#0046E1',
                                        top: '0',
                                        left: '100%',
                                        fontSize: '10px',
                                        width: '16px',
                                        height: '16px',
                                        padding: 0
                                    }}
                                >
                                    2
                                </span>
                            </Link>
                        </div>
                    </div>
                </div>

                {/* Nav & Search Area */}
                <div className="py-12 border-bottom border-gray-100">
                    <div className="container d-flex justify-content-between align-items-center">
                        {/* Left: Nav */}
                        <nav className="d-flex gap-32 fw-medium text-14">
                            <Link to="/" className={currentPath === '/' ? "text-decoration-none" : "text-gray-500 hover-text-primary text-decoration-none"} style={currentPath === '/' ? { color: colors.navActive || '#2563EB' } : {}}>
                                Home
                            </Link>
                            <Link to="/products" className={currentPath.startsWith('/products') ? "text-decoration-none" : "text-gray-500 hover-text-primary text-decoration-none"} style={currentPath.startsWith('/products') ? { color: colors.navActive || '#2563EB' } : {}}>
                                Product
                            </Link>
                            <Link to="/contact-us" className={currentPath.startsWith('/contact-us') ? "text-decoration-none" : "text-gray-500 hover-text-primary text-decoration-none"} style={currentPath.startsWith('/contact-us') ? { color: colors.navActive || '#2563EB' } : {}}>
                                Contact Us
                            </Link>
                        </nav>

                        {/* Right: Search */}
                        <div className="position-relative" style={{ width: '300px' }}>
                            <input
                                type="text"
                                className="form-control rounded-pill px-10 text-12 border-gray-200 shadow-none"
                                placeholder="Search for a product"
                                style={{ height: '40px', backgroundColor: '#ffffff', color: '#666' }}
                            />
                            <div
                                className="position-absolute top-50 translate-middle-y rounded-circle d-flex align-items-center justify-content-center text-white"
                                style={{
                                    backgroundColor: colors.primary || '#000',
                                    right: '4px',
                                    width: '32px',
                                    height: '32px',
                                    cursor: 'pointer'
                                }}
                            >
                                <MagnifyingGlass
                                    size={16}
                                    style={{
                                        color: colors.accountTitle || '#fff'
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Mobile Header */}
            <div className="d-md-none border-bottom border-gray-100">
                {/* Top: Logo */}
                <div className="py-12 d-flex justify-content-center align-items-center">
                    <span className="fw-bold fs-4" style={{ letterSpacing: '2px', color: '#000' }}>
                        {websiteData?.shopName || "COMPANY LOGO"}
                    </span>
                </div>
                {/* Bottom: Icons */}
                <div className="px-3 pb-3 d-flex justify-content-between align-items-center">
                    <List size={28} className="text-gray-800" style={{ cursor: 'pointer' }} />
                    <MagnifyingGlass size={24} className="text-gray-800" style={{ cursor: 'pointer' }} />
                </div>
            </div>
        </header>
    );
};

export default TemplateHeader;
